var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9972 11.8433H17.5586V34.1957H29.9972V11.8433Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3481 23.0202C18.3462 20.8675 18.834 18.7426 19.7747 16.8063C20.7153 14.87 22.0842 13.173 23.7776 11.844C21.6806 10.1956 19.162 9.17053 16.5099 8.88588C13.8578 8.60122 11.1791 9.06848 8.77995 10.2343C6.38083 11.4 4.35809 13.2173 2.94295 15.4783C1.52781 17.7393 0.777344 20.3528 0.777344 23.0202C0.777344 25.6875 1.52781 28.3011 2.94295 30.5621C4.35809 32.8231 6.38083 34.6404 8.77995 35.8061C11.1791 36.9719 13.8578 37.4392 16.5099 37.1545C19.162 36.8699 21.6806 35.8448 23.7776 34.1964C22.0842 32.8674 20.7153 31.1704 19.7747 29.2341C18.834 27.2978 18.3462 25.1729 18.3481 23.0202V23.0202Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7769 23.0202C46.777 25.6875 46.0267 28.3011 44.6116 30.5621C43.1965 32.8231 41.1738 34.6403 38.7748 35.8061C36.3757 36.9719 33.697 37.4392 31.0449 37.1545C28.3929 36.8699 25.8744 35.8448 23.7773 34.1964C25.4693 32.866 26.8371 31.1688 27.7776 29.2328C28.7181 27.2968 29.2068 25.1725 29.2068 23.0202C29.2068 20.8678 28.7181 18.7436 27.7776 16.8076C26.8371 14.8716 25.4693 13.1744 23.7773 11.844C25.8744 10.1956 28.3929 9.17052 31.0449 8.88587C33.697 8.60122 36.3757 9.06849 38.7748 10.2343C41.1738 11.4001 43.1965 13.2173 44.6116 15.4783C46.0267 17.7393 46.777 20.3529 46.7769 23.0202V23.0202Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4221 31.8286V31.371H45.6067V31.2778H45.1367V31.371H45.3213V31.8286H45.4221ZM46.3345 31.8286V31.2769H46.1904L46.0248 31.6564L45.859 31.2769H45.7149V31.8286H45.8166V31.4124L45.972 31.7712H46.0775L46.2329 31.4115V31.8286H46.3345Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.093de4661182be4cc5849e0a840b2ab5.svg";
export { ForwardRef as ReactComponent };